var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg72Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 400",
    style: {
      enableBackground: "new 0 0 700 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#152EA9;}\n\t.st1{fill:#32C89C;}\n\t.st2{fill:#00AAB8;}\n\t.st3{fill:#75E600;}\n\t.st4{fill:#52D65A;}\n\t.st5{fill:#00BEFF;}\n\t.st6{fill:#059AEA;}\n\t.st7{fill:#1052BF;}\n\t.st8{fill:#0B76D4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.1,328.2c-20.6,0-34.8-14.3-34.8-34.9c0-20,12.5-35.1,33.2-35.1c6.4,0,13.8,2,19.6,4.6l-4.1,10.1 c-5-2.2-10.2-3.9-15.7-3.9c-13.1,0-19.7,11-19.7,23.1c0,14.5,7.7,25.2,23.1,25.2c4.7,0,9.2-1.2,13.4-3.2l3.2,9.5 C167.7,326.5,161.4,328.2,155.1,328.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,286.7c-8.9,0-11.7,8.2-11.7,15.7c0,7.6,2.9,15.6,11.7,15.6c8.9,0,11.7-8.1,11.7-15.6 C211.7,295,208.9,286.7,200,286.7 M200,328.3c-15.2,0-24.9-11.2-24.9-25.9c0-14.8,9.7-25.9,24.9-25.9c15.2,0,24.9,11,24.9,25.9 C225,317.2,215.2,328.3,200,328.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.9,327.2V296c0-6.1-4-9.1-9.9-9.1c-3.4,0-6.8,1-10,2.2c0,0,0.2,1.4,0.2,2.1l0,36.1h-11.9v-38.9 c0-2.4-0.7-7-0.7-7c6.9-2.5,15.2-5,22.6-5c12.1,0,21.6,4,21.7,17.7v33.1H263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.3,329c-9,0-15.3-4.2-15.3-13.8v-27.4l-5.7-0.3V278l5.7-0.3v-13.8h11.9v13.6h13.9v10.4h-13.9v26.4 c0,3.1,1.6,4.3,4.6,4.3c3.1,0,6-1,8.9-2l3.3,9.6C312.3,327.7,308,329,303.3,329"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.4,287.7c-1.6-0.5-4.4-1-6.6-1c-3,0-6.1,0.4-9,1.3c0,0,0.1,0.7,0.1,1v38.2h-11.9v-37.9 c0-2.5-0.9-7.4-0.9-7.4c7.2-3,14.8-5.5,22.7-5.5c3.1,0,6.5,0.4,9.1,1.1L349.4,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.4,286.7c-8.8,0-11.7,8.2-11.7,15.7c0,7.6,2.9,15.6,11.7,15.6c8.9,0,11.7-8.1,11.7-15.6 C389.1,295,386.2,286.7,377.4,286.7 M377.4,328.3c-15.2,0-24.9-11.2-24.9-25.9c0-14.8,9.7-25.9,24.9-25.9c15.2,0,25,11,24.9,25.9 C402.3,317.2,392.6,328.3,377.4,328.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "421.5,254.2 409.6,254.2 409.6,305.4 409.6,327.2 421.5,327.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.7,328.3c-5.7,0-11.4-1.4-16.4-3.3l3.5-9.4c3.5,1.5,8.2,3,11.9,3c3.7,0,7.5-1.1,7.5-5.5 c0-8.8-21.7-6.2-21.7-22.5c0-10.2,10.6-14.3,18.4-14.3c5.3,0,10.5,1.2,14.3,3l-3.4,9.3c-3.2-1.2-7.6-2.3-11-2.3 c-3,0-6.2,0.9-6.2,4.5c0,8.4,22.7,4.6,22.7,22.5C464.5,324.4,453.7,328.3,444.7,328.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.8,244c-2.8,1-7.1,2.1-10.9,3.1l-2.2-10.7c2.4-0.4,5.4-1,7.4-1.8c6.9-2.4,7.5-7.4,7.5-15.4v-50.7H83v48.8 C83,230.7,81.1,239.6,68.8,244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,195.5c-8.8,0-11.7,8.1-11.7,15.7c0,7.5,2.9,15.6,11.7,15.6c8.9,0,11.7-8,11.7-15.6 C127.2,203.7,124.3,195.5,115.4,195.5 M115.4,237c-15.2,0-24.9-11.1-24.9-25.9c0-14.8,9.7-26,24.9-26c15.2,0,25,11,25,26 C140.4,226,130.6,237,115.4,237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.8,235.9v-31.4c0-5.5-3.4-9-8.3-9c-3.9,0-8.2,1.7-11.5,3.7v36.8h-11.9l0-72.9H160v25.4 c4.6-2,9.6-3.3,14.7-3.3c11.1,0,17,6.6,17,17.6v33.2H179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.5,235.9v-31.2c0-6.1-4-9.2-9.8-9.2c-3.4,0-6.9,1-10,2.2c0,0,0.2,1.4,0.2,2.1v36h-11.9v-38.8 c0-2.4-0.7-7-0.7-7c7-2.5,15.2-5,22.6-4.9c12.1,0,21.7,3.9,21.7,17.7v33.1H233.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.7,237c-5.7,0-11.4-1.4-16.4-3.3l3.5-9.3c3.5,1.5,8.2,3,11.9,3c3.7,0,7.6-1.1,7.6-5.5 c0-8.9-21.7-6.2-21.7-22.5c0-10.2,10.5-14.3,18.4-14.3c5.3,0,10.5,1.2,14.3,3l-3.4,9.3c-3.2-1.2-7.6-2.3-10.9-2.3 c-3,0-6.2,0.9-6.2,4.5c0,8.4,22.7,4.6,22.7,22.6C288.5,233.1,277.7,237,268.7,237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.7,195.5c-8.9,0-11.7,8.2-11.7,15.7c0,7.5,2.9,15.6,11.7,15.6c8.8,0,11.7-8,11.7-15.6 C330.4,203.7,327.6,195.5,318.7,195.5 M318.7,237c-15.2,0-25-11.1-25-25.9c0-14.8,9.7-25.9,25-26c15.2,0,25,11,25,26 C343.7,226,333.9,237,318.7,237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383,235.9v-31.2c0-6.1-4-9.2-9.8-9.2c-3.4,0-6.8,1-10,2.2c0,0,0.2,1.4,0.2,2.1v36h-11.9v-38.8 c0-2.4-0.7-7-0.7-7c6.9-2.5,15.2-5,22.5-5c12.1,0,21.7,4,21.7,17.7v33.1H383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M617.9,98.8c-1.3-1.3-2.6-2.6-4-3.9c-14.6,6.9-26.6,15.5-35.8,25.6c1.2,7.9,2,16.1,2.4,24.4 c1.3,28.9-3,53-11.3,72.6c6.2,10.5,14.8,20,25.9,27.8c3.2-1.7,6.2-3.6,9.1-5.6c-16.9-19.7-25.2-44-23.7-70.1 C582,141.6,596,116.8,617.9,98.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M596.3,82.4c-1.6-0.9-3.3-1.8-5-2.6c-7,3.2-13.6,7-19.8,11.2c1.2,4.2,2.4,8.5,3.4,12.9 C581.7,96.2,589,89,596.3,82.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M569.4,254.5c3.9-0.8,7.7-1.8,11.4-3c-6.1-6.8-12.1-14.3-17.4-22.4c-2.7,4.7-5.6,9.1-8.7,13.1 C559.2,246.6,564.1,250.7,569.4,254.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M641.7,142.3c-9.5,8.1-16,18.6-18.1,30.6c-2.3,12.9,0.8,25.8,8.1,37.2c8-13.7,12.6-29.6,12.6-46.6 C644.2,156.2,643.3,149.1,641.7,142.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M613.2,171.2c1.9-17.7,8.5-36.3,20.5-50.5c-0.9-1.8-1.9-3.5-2.9-5.2c-22.9,12.5-37.7,32.3-39.9,56.7 c-1.9,21.5,8.1,43,24.6,58.4c2.5-2.4,5-5,7.2-7.7C614.8,207.6,611.2,190.2,613.2,171.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M487,96.8c-16,15.5-26.5,36.7-28.1,60.3C474.4,142.3,484,118.5,487,96.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M505.3,83c-1.4,0.8-2.8,1.7-4.2,2.6c-8.9,41.7-23.5,69.4-41.5,90.6c0.7,4.7,1.6,9.3,3,13.7 C500.4,166.6,508.4,114.6,505.3,83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580.8,144.9c-1.1-26.6-6.7-51.4-15.6-73.2c-1.8-0.3-3.6-0.5-5.4-0.6c8.3,70.3,0.2,138.1-40.9,179.2 c7.4,2.8,15.2,4.6,23.3,5.4C567.6,233.6,583,196.7,580.8,144.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M544.6,71c-1.8,0.1-3.5,0.3-5.3,0.5c1.7,45.8-6.1,121.7-51.3,159.7c4.2,3.9,8.7,7.5,13.6,10.5 C560.3,202,560,124.1,544.6,71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M524.1,74.9c-1.6,0.5-3.1,1-4.6,1.5c-2.7,47.1-15.3,97.3-50.7,129.3c2.3,4.5,5,8.8,8,12.9 C524.8,189.6,534.6,121,524.1,74.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg72Image);
export default __webpack_public_path__ + "static/media/72_Image.739636421c352264b1f710cac8b7a3f7.svg";
export { ForwardRef as ReactComponent };